import React, { useState,useEffect } from 'react';
import {Box,Typography,Button} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import ContentDialog from '../Components/ContentDialog';
import { add_test } from '../Redux/testSlice';
import { add_tests } from '../Redux/testsSlice';
import get_results_all from "../Redux/reducers/get_results_all"
import { FileOpen, TitleRounded } from '@mui/icons-material';
import { Alarm, ArrowCircleRightOutlined, ArrowDropDownOutlined, CalendarTodayOutlined, CopyAllRounded, FileOpenTwoTone, NumbersTwoTone, QuizOutlined, Remove } from '@mui/icons-material';
import ResultDetailDialog from './ResultDetailDialog';
import ResultAssDetailDialog from './ResultAssDetailDialog';

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography  style={{fontWeight:500,fontSize:13,color:'white',marginTop:9}}> {displayText} </Typography>
}

const ResultText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Button style={{fontWeight:500,fontSize:11,color:'white',fontFamily:"dinofans",color:"gold",borderWidth:0}}> {displayText} </Button>
}

const ResultDialog = ({visible,setVisible})=>{

const theme = useTheme()
const user = useSelector(state => state?.auth.user);
const [results, setResults] = useState([]);
const [loading,setLoading] = useState(false)
const [result, setResult] = useState("");
const [score, setScore] = useState(0);
const [showAssResultModal, setShowAssResultModal] = useState(false);
const [showResultModal, setShowResultModal] = useState(false);
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const dispatch = useDispatch()

const onOpen = () => {
	setVisible(true);
};
const onClose = () => {
	setVisible(false);
};

useEffect(()=>{
	get_results_all(user?.email,setResults,user?.accessToken,setLoading)
},[])

return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Results
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{height:800,width:{xs:300,md:400},justifyContent:"center",background:theme.palette.background.default}}>
			<Box justifyContent="center" alignItems="center">
			  {
                (results?.length == 0 && !loading) && (
					<Box justifyContent="center" alignItems="center"  p={1}>
						<Box justifyContent="center" alignItems="center" >
							<img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
						</Box>
                    	<Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:5}}>
                       		Results could not be found
                      </Typography> 
                  </Box>
                )
              }
              {
                (results?.length == 0 && loading) && (
					<Box justifyContent="center" alignItems="center"  p={1}>
						<Box justifyContent="center" alignItems="center" >
							<img width={50} height={80} src={require("../assets/yes.gif")} alt="keep up" />
						</Box>
                    	<Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:5}}>
                       		Wait a moment ...
                      </Typography> 
                  </Box>
                )
              } 
              {
                results?.map((item,index)=>{
                  return(
                    <Box key={index} sx={{padding:1,background:"black",borderRadius:2,margin:1,width:"100%",justifyContent:"flex-start",alignContent:"flex-start"}}>
                        <Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="flex-start">
							<ResultText text={`# ${index+1}  ${item?.title}`} limit={25}/>
							<Typography sx={{fontSize:11}} pb={1} pt={1} >
								{item?.test_date}
							</Typography>									
						</Box>
						<Box display="flex" flexDirection="row" justifyContent={item?.conclusion === "pending" ? "flex-start" :  "space-between"} alignItems="center" width="90%">
							<Typography width={45} p={1} ml={3} borderRadius={2} sx={{fontSize:12,color:(item?.conclusion !== "pending" ? "white" : "black"),background:(item?.conclusion === "pending" ? "gold" : item?.conclusion === "fail" ? "red" : "green")}}>
								{item?.score} %
							</Typography>
							{
							((item?.conclusion === "fail" || item?.conclusion === "accept") && !item?.isDisqualified) && (
								<Button onClick={()=>{
									setResult(item?.data)
									setScore(item?.score)
									if(item?.isTest){
										setShowResultModal(true)
									}else{
										setShowAssResultModal(true)
									}
								}} sx={{background:"gold",color:"black",borderColor:"gold",fontFamily:"dinofans",fontSize:9}} variant="contained">
									Result
								</Button>                                    
							)}								
							{
								item?.isDisqualified && (
									<Typography  p={1} ml={1} borderRadius={2} sx={{fontSize:12,color:"white",background:"red"}}>
										You have been Disqualified
									</Typography>
								)
							}								
						</Box>
						{
							!item?.isDisqualified && (
								<DescriptionText text={item?.description} limit={120}/> 
							)
						}
                    </Box>
                  )
                })
              } 
			</Box>
			<ResultDetailDialog visible={showResultModal} setVisible={setShowResultModal} content={result}/>
			<ResultAssDetailDialog score={score} visible={showAssResultModal} setVisible={setShowAssResultModal} content={result}/>
		</DialogContent>
	</Dialog>
	)
}

export default ResultDialog